import { render } from "./GalleryItem.vue?vue&type=template&id=236222d6&scoped=true"
import script from "./GalleryItem.vue?vue&type=script&lang=js"
export * from "./GalleryItem.vue?vue&type=script&lang=js"

import "./GalleryItem.vue?vue&type=style&index=0&id=236222d6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-236222d6"

export default script